import React from "react";
import { ReactComponent as EmmptyLiabilities } from "../../assets/images/svg/emptyLiabilities.svg";

const EmptyLiabilities = ({ message }) => {
  return (
    <div className="empty_liabilities_outside">
      <div className="empty_liabilities_main">
        <EmmptyLiabilities />
        <h2 className="empty_comment">{message}</h2>
      </div>
    </div>
  );
};

export default EmptyLiabilities;
